<template>
  <div class="page-bg" aria-hidden="true">
    <div class="page-bg-gradient"></div>
    <svg class="page-bg-grid" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="shoplazza-grid" width="40" height="40" patternUnits="userSpaceOnUse">
          <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#0f172a" stroke-width="1" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#shoplazza-grid)" />
    </svg>
    <div class="page-bg-orb page-bg-orb-green"></div>
    <div class="page-bg-orb page-bg-orb-blue"></div>
  </div>
</template>

<script>
export default {
  name: 'ShoplazzaPageBackground',
}
</script>

<style lang="scss" scoped>
.page-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.page-bg-gradient {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #f0fdf4 0%, #f8fafc 45%, #eff6ff 100%);
}

.page-bg-grid {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0.04;
}

.page-bg-orb {
  position: absolute;
  border-radius: 50%;
}

.page-bg-orb-green {
  top: -15%;
  right: -8%;
  width: 600px;
  height: 600px;
  opacity: 0.18;
  background: radial-gradient(circle, #22c55e 0%, transparent 70%);
}

.page-bg-orb-blue {
  bottom: -15%;
  left: -8%;
  width: 500px;
  height: 500px;
  opacity: 0.1;
  background: radial-gradient(circle, #3b82f6 0%, transparent 70%);
}
</style>
